import { getData } from '../modules/fetch';

const getAgentPerformances = (params, callback) => {
  const paramsObj = params || {};
  
  const searchParams = new URLSearchParams({
    startDate: paramsObj.startDate || '',
    endDate: paramsObj.endDate || '',
    userIds: paramsObj.userIds || ''
  });

  const url = `/performances/?${searchParams.toString()}`;

  getData(url)
    .then((data) => {
      if (data)
        callback(data);
    })
    .catch((err) => {
      console.error(err);
      callback({ error: err.message || 'An error occurred' });
    });
}

export default getAgentPerformances;
